<template>
  <v-card :loading="loading" width="500">
    <v-card-text class="pb-0">
      <v-row no-gutters justify="center" align="center" class="py-5">
        <img src="@/assets/images/logo.png" width="70" alt="" class="mr-4" />
      </v-row>
    </v-card-text>

    <v-card-text>
      <v-form v-model="valid" @submit.prevent="login">
        <v-row no-gutters>
          <v-text-field
            outlined
            dense
            v-model="formData.email"
            :rules="formRules.email"
            label="Email"
            name="email"
            prepend-icon="mdi-email"
            type="text"
          ></v-text-field>
        </v-row>

        <v-row no-gutters>
          <v-text-field
            outlined
            dense
            id="password"
            v-model="formData.password"
            :rules="formRules.password"
            label="Password"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
          ></v-text-field>
        </v-row>

        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-btn
            text
            :loading="loading"
            color="primary"
            type="submit"
            depressed
          >
            Log in
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { me, login } from '@/graphql/auth.gql'
import { onLogin } from '@/vue-apollo'
import swal from 'sweetalert2'

export default {
  name: 'AuthLoginForm',
  data: () => ({
    valid: false,
    loading: false,
    formData: {
      email: '',
      password: ''
    },
    formRules: {
      email: [
        v => !!v || 'Email is required.',
        v => /.+@.+\..+/.test(v) || 'Must be a valid email.'
      ],
      password: [v => !!v || 'Password is required.']
    }
  }),
  methods: {
    login() {
      this.loading = true

      this.$apollo
        .mutate({
          mutation: login,
          variables: {
            data: this.formData
          }
        })
        .then(({ data }) => {
          onLogin(this.$apollo.provider.defaultClient, data.login.access_token)

          this.$nextTick(() => {
            this.$apolloProvider.defaultClient
              .query({
                query: me
              })
              .then(data => {
                this.$store.commit('auth/SET_CURRENT_USER', data.data.me)

                if (this.$route.query.redirect) {
                  this.$router.push({ name: this.$route.query.redirect })
                } else {
                  this.$router.go()
                }
              })

            this.loading = false
          })
        })
        .catch(error => {
          this.handleGraphQLErrors(error)

          this.loading = false
        })
    }
  }
}
</script>
